import { Note } from '../../shared/notes/note.model';
import { Communication } from '../../shared/communications/communication.model';
import { Company } from '../companies/company.model';
import { EventBB } from '../events/event.model';
import { Task } from '../../shared/tasks/task.model';
import { Attachment } from '../../shared/attachments/attachment.model';

export class Contact {

  _id?: string;
  reference?: number;
  salutation?: string;
  fullName?: string;
  firstName?: string;
  lastName?: string;
  jobTitle?: string;

  // emails
  website?: string;
  email?: string;
  confidentialEmail?: string;

  // phone numbers
  telephone?: string;
  mobile?: string;
  ddi?: string;
  switchboard?: string;
  confidentialNumber?: string;

  // assistant details
  assistantName?: string;
  assistantEmail?: string;
  assistantPhone?: string;

  // Main Address
  line1?: string = '';
  line2?: string = '';
  city?: string = '';
  postcode?: string = '';
  county?: string = '';
  country?: string = '';

  // Alternative address
  otherLine1?: string = '';
  otherLine2?: string = '';
  otherCity?: string = '';
  otherPostcode?: string = '';
  otherCounty?: string = '';
  otherCountry?: string = '';

  // is Ambassador tagging
  isAmbassador?: boolean = false;
  hasSignedAmbassadorNDA?: boolean = false;

  /* eventually move this away */
  logoUrl?: string;
  companyName?: string;

  referrals?: Company[] = [];
  companies?: Company[] = [];
  tasks?: Task[] = [];
  communications?: Communication[] = [];
  eventsAttended?: EventBB[] = [];
  notes?: Note[] = [];
  attachments?: Attachment[] = [];

  // contact preferecnes
  doNotContact?: boolean = false;
  contactComments?: string;
  //
  createdAt?: Date;
  updatedAt?: Date;

  constructor() {

  }


  filterQueryCreate(filterStrings: string[] = []) {

    const filterQuery = Object.entries(this)
      .filter(([key, value]) => ((!Array.isArray(value) && value) || (Array.isArray(value) && value.length > 0))) // filters out the blanks and zero arrays
      .map(
        ([key, value]) => {

          if (value === true || value === false) {
            return `${key}=${value}`; // for true/false types we want to do this
          } else if (Array.isArray(value)) {
            // const arraySplit = value.join(',');
            return `${key}=${value}`; // this lets us do a like query
          } else {
            return `${key}=%2F${value}%2Fi`; // this lets us do a like query
          }
        }
      ).join('&');

    // console.log('Filter Query', filterQuery);

    return filterQuery;

  }



}



// WEBPACK FOOTER //
// ./client/app/features/contacts/contact.model.ts